import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { ConfirmPopoverModule } from '../shared/components/confirm-popover/confirm-popover.module';
import { ApprovalCardComponent } from './components/approval-card/approval-card.component';
import { ChatConversationComponent } from './components/chat-conversation/chat-conversation.component';
import { ChatInputComponent } from './components/chat-input/chat-input.component';
import { ChatMessageComponent } from './components/chat-message/chat-message.component';
import { ChatSkeletonComponent } from './components/chat-skeleton/chat-skeleton.component';
import { ChatSuggestionsComponent } from './components/chat-suggestions/chat-suggestions.component';
import { ComposerMenuComponent } from './components/composer-menu/composer-menu.component';
import { FilePickerModalComponent } from './components/file-picker-modal/file-picker-modal.component';
import { InformationChipComponent } from './components/information-chip/information-chip.component';
import { KnowledgeMenuComponent } from './components/knowledge-menu/knowledge-menu.component';
import { MessageAttachmentComponent } from './components/message-attachment/message-attachment.component';
import { MessageChartComponent } from './components/message-chart/message-chart.component';
import { PreferencesModalComponent } from './components/preferences-modal/preferences-modal.component';
import { AutomationFormComponent } from './components/preferences-modal/sections/automations-section/automation-form/automation-form.component';
import { AutomationsSectionComponent } from './components/preferences-modal/sections/automations-section/automations-section.component';
import { ConnectorsSectionComponent } from './components/preferences-modal/sections/connectors-section/connectors-section.component';
import { GeneralSectionComponent } from './components/preferences-modal/sections/general-section/general-section.component';
import { KnowledgeSectionComponent } from './components/preferences-modal/sections/knowledge-section/knowledge-section.component';
import { MemoriesSectionComponent } from './components/preferences-modal/sections/memories-section/memories-section.component';
import { PluginSectionComponent } from './components/preferences-modal/sections/plugin-section/plugin-section.component';
import { QuickActionsMenuComponent } from './components/quick-actions-menu/quick-actions-menu.component';

@NgModule({
  declarations: [
    ApprovalCardComponent,
    ChatConversationComponent,
    ChatInputComponent,
    ChatMessageComponent,
    ChatSkeletonComponent,
    ChatSuggestionsComponent,
    ComposerMenuComponent,
    FilePickerModalComponent,
    AutomationFormComponent,
    AutomationsSectionComponent,
    ConnectorsSectionComponent,
    GeneralSectionComponent,
    InformationChipComponent,
    KnowledgeMenuComponent,
    KnowledgeSectionComponent,
    MemoriesSectionComponent,
    MessageAttachmentComponent,
    MessageChartComponent,
    PluginSectionComponent,
    PreferencesModalComponent,
    QuickActionsMenuComponent,
  ],
  imports: [
    CommonModule,
    ConfirmPopoverModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  exports: [
    ApprovalCardComponent,
    ChatConversationComponent,
    ChatInputComponent,
    ChatMessageComponent,
    ChatSkeletonComponent,
    ChatSuggestionsComponent,
    InformationChipComponent,
    KnowledgeMenuComponent,
    MessageAttachmentComponent,
    MessageChartComponent,
    PreferencesModalComponent,
    QuickActionsMenuComponent,
  ],
})
export class ChatSharedModule {}
